'use client';

import Button from '@/components/Button';
import SideDrawer from '@/components/Drawer';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faClose, faBars } from '@fortawesome/pro-thin-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useLayoutEffect, useState } from 'react';
import { twMerge } from 'tailwind-merge';
import Heading from '../Heading';
import MainMenu from '../MainMenu';

function MainNavBar({ className }: { className?: string } ) {
  const [showMenu, setShowMenu] = useState(false)
  const router = useRouter();

  router.events?.on('routeChangeStart', () => {
    setShowMenu(false);
    return true;
  })

  return (
    <div
      className={twMerge(
        'bg-sharp-darkglass md:bg-darkglass md:rounded-xl flex md:flex-col md:h-[calc(100vh-64px)] md:pt-8 md:p-0 sticky top-0 md:top-8 z-20 min-w-[80px] md:w-full md:max-w-[80px] xl:min-w-[240px]',
        className
      )}
    >
      <header className="flex gap-0">
        <div className="flex-none flex md:hidden items-center justify-center px-4">
          <Button type="Link" onClick={() => setShowMenu(!showMenu)} className="size-10">
            <FontAwesomeIcon icon={(showMenu ? faClose : faBars) as IconProp} className="w-6 h-6 text-white text-xl self-center" />
          </Button>
        </div>
        <div className="flex flex-auto py-6 xl:px-6">
          <Link href="/" className='mx-auto w-auto xl:w-full'>
            <Image
              src="/images/bloom-landscape-white-logo.svg"
              alt="Bloom"
              width={136}
              height={41}
              className="md:hidden xl:inline-flex"
            />
            <Image
              src="/images/bloom.svg"
              alt="Bloom"
              width={40}
              height={40}
              className="hidden md:inline-flex xl:hidden"
            />
          </Link>
        </div>
      </header>

      <MainMenu className="flex-grow  hidden md:flex flex-col justify-center lg:items-start" />

      <SideDrawer open={showMenu} setOpen={() => setShowMenu(!showMenu)} className="md:hidden">
        <MainMenu className="main-menu flex flex-col justify-bewee lg:items-start overflow-hidden" />
      </SideDrawer>
    </div>
  );
}

export default MainNavBar;
